<template>
  <v-container class="pa-0">
    <h1 class="display-1 font-weight-light">{{ title }}</h1>
    <v-row justify="center">
      <v-col cols="12">
        <v-text-field
          :label="$t('explore.labels.search')"
          v-model="search"
          rounded
          outlined
          append-icon="search"
          full-width
          hide-details
          @keyup.native.enter="searchVideos"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" xl="2"  v-for="(video, index) in videos" :key="index" v-show="isIndexInPage(index)">
        <video-card :id_video="video.id"></video-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-pagination
          v-if="pages"
          v-model="page"
          :length="pages"
          circle
          next-icon="chevron_right"
          prev-icon="chevron_left"
        ></v-pagination>
        <span v-else-if="list_videos.length > 0">{{ $t('library.messages.no-results') }}</span>
      </v-col>
    </v-row>
    <v-overlay :value="!loaded" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>

// import { getUrlImage } from '@/store/storage'
import { getVideos } from '@/store/module/explore'
import VideoCardComponent from '@/components/VideoCard'

export default {
  components: {
    'video-card': VideoCardComponent
  },
  data: () => ({
    loaded: false,
    videos: [],
    list_videos: [],
    title: '',
    search: '',
    page: 1,
    pages: null,
    items_per_page: 8
  }),

  mounted() {
    this.title = this.$t('explore.titles.main')
    this.searchVideos()
  },

  methods: {
    getTerms() {
      let query = this.search ? this.search.trim() : ''

      let chars = ['.', ',', ';', ':', '-', '+', '_', '(', ')']
      for (let char of chars) {
        query = query.split(char).join('')
      }

      let terms = query.split(" ")
      let words = terms.map(v => v.toLowerCase())
      words = words.filter(w => w.length > 2)
      return words.filter((v, i, a) => a.indexOf(v) === i)
    },
    searchVideos() {
      this.loaded = false
      this.pages = null
      let terms = this.getTerms()
      getVideos(this.$store.getters.user.data.plan.id, terms)
      .then(videos => {
        this.pages = Math.ceil(videos.length / this.items_per_page)
        this.page = 1
        this.videos = videos
        this.loaded = true
      })
    },
    isIndexInPage(index) {
      let page = (index + 1) / this.items_per_page
      return Math.ceil(page) <= this.page
    },
    getVideoTerms(search) {
      let words = search.split(" ")
      words = words.map(v => v.toLowerCase());
      return words.filter((v, i, a) => a.indexOf(v) === i)
    }
  }
}

</script>
